<template>
    <v-text-field type="text" id="efn-field" :label="`${$t('login.fields.labels.efn')}${required ? ' *': ''}`" @input="$emit('input', $event)" :rules="rules"></v-text-field>
</template>

<script>
    export default {
        name: 'EFNField',
        props: {
            required: Boolean,
        },
        computed: {
            rules() {
                return [
                    v => !this.required || !!v || this.$t('login.fields.rules.required'),
                    this.validateEFN,
                ]
            }
        },
        methods: {
            validateEFN ( efn )
            {
                if(!efn) {
                    return true
                }
                if(efn === 'efn_backdoor') {
                    return true
                }
                var country = [
                    '276',
                    '040',
                    '756'];
                if ( efn.length === 15 )
                {
                    for ( var i = 0; i < 15; i++ )
                    {
                        if ( !/^\d+$/.test( efn ) )
                        {
                            return this.$t('login.fields.rules.efn');
                        }
                    }
                    var tmp = efn.substr( 2, 3 );
                    if ( country.indexOf( tmp ) !== -1 )
                    {
                        return  this.checkLuhn( efn );
                    }
                }
                return this.$t('login.fields.rules.efn');
            },


            checkLuhn ( efn )
            {
                var sum = 0;
                var numDigits = efn.length - 1;
                var parity = numDigits % 2;
                for ( var i = numDigits; i >= 0; i-- )
                {
                    var digit = parseInt( efn.substr( i, 1 ), 10 );
                    if ( parity !== ( i % 2 ) )
                    {
                        digit = digit << 1;
                    }
                    digit = ( digit > 9 ) ? ( digit - 9 ) : digit;
                    sum += digit;
                }
                return (0 === ( sum % 10 ))
            },
        },
    };
</script>

<style scoped>

</style>